import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { ArrowLeftRight, CalendarClock, CircleDot } from "lucide-react";

const QB_STATUS_MAP = {
  Pending: "pending",
  Accepted: "confirmed",
  Converted: "confirmed",
  Closed: "declined",
  Rejected: "declined",
};

function formatDate(dateStr) {
  if (!dateStr) return "N/A";
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

export function QBOverrideIndicator({ event }) {
  if (!event.qb_estimate_id) return null;

  const overrides = [];

  // Status override check
  const expectedStatus = QB_STATUS_MAP[event.qb_status] || "pending";
  const statusOverridden = event.qb_status && event.status !== expectedStatus
    && !(expectedStatus === "confirmed" && event.status === "completed");
  if (statusOverridden) {
    overrides.push({
      type: "status",
      label: "Status",
      qbValue: event.qb_status,
      dashValue: event.status,
    });
  }

  // Date override check
  if (event.qb_event_date && event.start_date !== event.qb_event_date) {
    overrides.push({
      type: "date",
      label: "Date",
      qbValue: formatDate(event.qb_event_date),
      dashValue: formatDate(event.start_date),
    });
  }

  if (overrides.length === 0) return null;

  return (
    <TooltipProvider delayDuration={200}>
      <div data-testid="qb-override-indicator" className="flex flex-wrap items-center gap-1.5 mt-1.5">
        <ArrowLeftRight className="w-3 h-3 text-amber-500/70" />
        {overrides.map((o) => (
          <Tooltip key={o.type}>
            <TooltipTrigger asChild>
              <span
                data-testid={`qb-override-${o.type}`}
                className="inline-flex items-center gap-1 text-[10px] font-medium tracking-wide uppercase px-1.5 py-0.5 rounded-sm bg-amber-500/10 text-amber-500 border border-amber-500/20 cursor-default"
              >
                {o.type === "date" ? <CalendarClock className="w-2.5 h-2.5" /> : <CircleDot className="w-2.5 h-2.5" />}
                {o.label} overridden
              </span>
            </TooltipTrigger>
            <TooltipContent side="bottom" className="text-xs">
              <div className="space-y-0.5">
                <div className="text-muted-foreground">QB: <span className="text-foreground font-medium">{o.qbValue}</span></div>
                <div className="text-muted-foreground">Dashboard: <span className="text-foreground font-medium">{o.dashValue}</span></div>
              </div>
            </TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  );
}
